import React, { useContext } from 'react'
import { BASE_COUNTRY_ISO, ESW_CLASSNAMES } from '../../constants'
import classNames from 'classnames'
import AppContext from '../context/app'
import PercentageOff from './percentage-off'
import PriceStriked from './price-striked'
import Price from './price'
import Placeholder from 'react-bootstrap/Placeholder'

export default function PriceDisplay(props) {
    const {
        cart,
        prices,
        country,
    } = useContext(AppContext)

    const {
        debug,
        item,
        product,
        quantity,
        showSaleInfo,
        className = '',
        style = {},
        attributes = {},
        eswPriceClassName = ESW_CLASSNAMES.PAGE_PRICE,
        eswPriceStrikedClassname = ESW_CLASSNAMES.PAGE_PRICE,
    } = props

    const property = process.env.GATSBY_ENVIRONMENT_PRODUCTION === 'true' ?
        'pimcoreProductionId' : 
        'pimcoreStagingId'

    const id = product[property]
    const iso = country?.countryIso || BASE_COUNTRY_ISO
    
    const price = (prices && prices[id]) ? prices[id][iso] : undefined
    const hasPromotion = price ? price.hasOwnProperty('promotion_price') : undefined

    // Different layout for sale info i.e. (crossed out price + percent off + sale name) above the final price
    if(showSaleInfo && prices && hasPromotion) return (
        <div
            {...attributes}
            style={style}
            className={classNames(
                className,
                attributes.className, 
            )}
        >
            <div
                className='d-flex gap-2'
                style={{ fontSize: '80%' }}
            >
                <PriceStriked
                    item={item}
                    product={product}
                    quantity={quantity}                    
                    eswPriceStrikedClassname={eswPriceStrikedClassname}
                />
                
                <span className='bg-primary d-flex align-items-center px-2'>
                    -<PercentageOff price={price} />%
                </span>

                <span className='d-flex align-items-center uppercase text-white bg-black px-2'>
                    {price?.promotion_name}
                </span>
            </div>
            <Price
                item={item}
                product={product}
                quantity={quantity}
                eswPriceClassName={eswPriceClassName}
            />
        </div>
    )
    
    return (
        <div
            {...attributes}
            style={style}
            className={classNames(
                attributes?.className,
                className,
            )}
        >
            {quantity && (
                <span className={classNames(
                    ESW_CLASSNAMES.CARTITEM_QUANTITY,
                    'visually-hidden',
                )}>
                    {quantity}
                </span>
            )}

            <Price
                item={item}
                product={product}
                quantity={quantity}
                eswPriceClassName={eswPriceClassName}
            />

            <PriceStriked
                item={item}
                product={product}
                quantity={quantity}
                style={{ fontSize: '80%' }}
                eswPriceStrikedClassname={eswPriceStrikedClassname}
            />

            {(Number(item?.discount_applied) > 0) && (
                <span
                    className='text-secondary'
                    style={{ fontSize: '70%' }}
                >
                    [{cart?.voucher_code}]
                </span>
            )}
        </div>
    )
}
